import React, { useEffect } from "react";
import moment from "moment";
import DateMomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { ThemeProvider, makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import * as Glob from "../../Globale";
import theme from "../theme";
import { _Footer, _Header } from "../layout";
import { _AlertDialog } from "../components";

const useStyles = makeStyles({
    "@global": {
        ".hidden": {
            display: "none"
        }
    }
});

export const _PageWrapper: React.FC<Glob.IGlobaleProps> = props => {
    useStyles();

    useEffect(() => {
        const session = Glob.GetSessione();

        document.title = `InAR - ${location.pathname} - Client: ${Glob.Version} Server: ${session.Versione} - ${session.ConfigurazioneCompilazione}`;
        document.querySelector('link[href*="assets/metronic/vendors.min.css"]')?.remove();
        document.querySelector('link[href*="assets/metronic/main-styles.css"]')?.remove();
    }, []);

    return (
        <ThemeProvider theme={theme}>
            <MuiPickersUtilsProvider libInstance={moment} utils={DateMomentUtils} locale={props.Globale[Glob.TTipiGlobale.Locale].Lingua}>
                <CssBaseline />
                <_AlertDialog Data={props.Globale[Glob.TTipiGlobale.Dialog]} SetDialog={props.SetDialog} />
                <_Header {...props} />
                {props.children}
                <_Footer {...props} />
            </MuiPickersUtilsProvider>
        </ThemeProvider>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/layout/PageWrapper.tsx